class Contract {
	id = null;
	contract_number = '';
	start_date = null;
	end_date = null;
	contract_type_id = null;
	teacher_id = null;
	teacher_ids = [];
	author_id = null;
	author = {};
	t1 = 0;
	t2 = 0;
	t3 = 0;
	t4 = 0;
	program_t1 = '';
	program_t2 = '';
	program_t3 = '';
	program_t4 = '';
	uploaded_file = {
		name: '',
		link: '',
		original_name: '',
		upload_id: null,
	};
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Contract;
